import { AppStoreApi } from '@/data-store/appStoreProvider';
import { BatteryEcommSlicePartial } from '@/tests/test-data/store/batteryEcommSliceData';
import { GlobalSlicePartial } from '@/tests/test-data/store/globalSliceData';
import { SolarEcommSlicePartial } from '@/tests/test-data/store/solarEcommSliceData';
import { SunrunShopSlicePartial } from '@/tests/test-data/store/sunrunShopSliceData';

export type OverrideValues = {
  sunrunShop?: Partial<SunrunShopSlicePartial>;
  solarEcomm?: Partial<SolarEcommSlicePartial>;
  batteryEcomm?: Partial<BatteryEcommSlicePartial>;
  global?: Partial<GlobalSlicePartial>;
};

/**
 *  Merges actual store state with mock state for both `state` and `actions` objects on the Zustand store,
 *  for each of our defined slices.
 */
export const overrideStoreValues = (
  store: AppStoreApi,
  override: OverrideValues
) => {
  Object.entries(override).forEach(([key, value]) => {
    store.setState((state) => {
      return {
        [key]: {
          ...state[key as keyof typeof state],
          ...value,
          actions: {
            ...state[key as keyof typeof state].actions,
            ...value.actions,
          },
        },
      };
    });
  });
};
